
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Redirect } from '@shopify/app-bridge/actions';
import { isShopifyEmbedded } from '@shopify/app-bridge/utilities';
import { EventBus } from '@/main';
import { get } from '@/services/http';

@Component
export default class InventoryTransferPermissionDialog extends Vue {
  @Prop({ default: false }) public value!: boolean;
  @Prop() public store: any;
  @Prop() public app: any;
  
  public loading: boolean = false;
  public installUrl: string = '';

  get dialog() {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit('input', val);
  }

  public closeDialog() {
    this.dialog = false;
  }

  public async requestPermission() {
    this.loading = true;
    
    try {
      // Get the current shop domain
      const shopDomain = this.store?.shopName || '';
      
      if (!shopDomain) {
        EventBus.$emit('show-snackbar', {
          message: 'Unable to determine shop domain. Please try again.',
          color: 'error'
        });
        this.loading = false;
        return;
      }

      // Store the current path to return to after auth
      localStorage.setItem('redirect_after_auth', window.location.pathname);

      // Get the install URL from backend (which includes updated scopes)
      const response: any = await get('/shopify/install?shop=' + shopDomain);
      this.installUrl = response.install_url;
      
      if (this.installUrl) {
        console.log('Redirecting to Shopify for permission grant');
        
        // Use Shopify App Bridge for embedded apps
        if (isShopifyEmbedded() && this.app) {
          Redirect.create(this.app).dispatch(Redirect.Action.REMOTE, this.installUrl);
        } else {
          // Direct redirect for non-embedded
          window.location.assign(this.installUrl);
        }
        
        // Reset state
        this.installUrl = '';
        this.closeDialog();
      } else {
        throw new Error('Failed to get authorization URL');
      }
    } catch (error) {
      console.error('Error requesting permission:', error);
      EventBus.$emit('show-snackbar', {
        message: 'Failed to request permission. Please try again.',
        color: 'error'
      });
      this.loading = false;
    }
  }
}
